"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const UUID = require("uuid");
import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import { ExtEbusinessModel } from "@/models/shop.model";
import API from "@ym-framework/api-utils";
import UiForm, { UiFormController } from "@/components/form/UiForm.vue";
import Question from "@/components/Question.vue";
import PasswordInput from "@/views/accountItems/components/PasswordInput.vue";
import ShopPlatforms from "@/views/virtualdesktopItems/components/dialog-forms/ShopPlatforms.vue";
import _ from "lodash";
export class VisitItemForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.ebusiness_platform_guid = "";
    this.lockAccount = false;
    this.account = null;
    this.password = null;
    this.name = null;
    this.ebusiness_id = null;
    this.logo_info = null;
  }
}
let VisitItem = class extends Vue {
  constructor() {
    super(...arguments);
    this.choose_custom_platform = false;
    this.edit_custom_platform = false;
    this.custom_platform_url = "";
    this.custom_platform_name = "";
    this.edit_custom_platform_url = "";
    this.edit_custom_platform_name = "";
    this.refresh_key = UUID.v4();
    this.mode = this.initmode;
    this.platformType = "all";
    this.selectedIds = {
      method: "create"
    };
    this.shopControl = new VisitItemForm();
  }
  get selected_item() {
    return this.selecteditem;
  }
  chooseCustom() {
    this.shopControl.name = null;
    this.custom_platform_url = "";
    this.custom_platform_name = "";
    this.choose_custom_platform = !this.choose_custom_platform;
  }
  editchooseCustom() {
    if (this.shopFlag) {
      this.shopControl.ebusiness_platform_guid = this.selected_item.ebusiness_id;
      this.shopControl.name = null;
      this.edit_custom_platform_name = this.selected_item.name;
      this.edit_custom_platform_url = this.selected_item.url;
      this.edit_custom_platform = !this.edit_custom_platform;
    } else {
      this.shopControl.name = null;
      this.edit_custom_platform_name = this.selected_item.name;
      this.edit_custom_platform_url = this.selected_item.url;
      this.edit_custom_platform = !this.edit_custom_platform;
    }
  }
  add() {
    return __async(this, null, function* () {
      var _a, _b;
      try {
        if (this.shopFlag) {
          if (this.choose_custom_platform) {
            const item = {
              "model": "custom",
              "ebusiness_id": UUID.v4(),
              "name": (_a = this.custom_platform_name) != null ? _a : "\u81EA\u5B9A\u4E49",
              "url": (_b = this.custom_platform_url) != null ? _b : "https://",
              "account": this.shopControl.account,
              "password": this.shopControl.password,
              "lockAccount": this.shopControl.lockAccount,
              "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/custom_small.png",
              "ebusiness_platform_guid": null,
              "custom": true,
              "id": null
            };
            this.$emit("success", { "method": "add", "item": item });
            this.setMode("add-btn");
            this.custom_platform_url = "";
            this.custom_platform_name = "";
          } else {
            if (this.shopControl.ebusiness_platform_guid === "" || this.shopControl.ebusiness_platform_guid === null) {
              this.$message.error(this.$t("visititem.add_platform_empty_error"));
              return;
            }
            let data = _.find(this.ebusinessList, { "ebusiness_id": this.shopControl.ebusiness_platform_guid });
            console.log(this.ebusinessList);
            console.log(this.shopControl.ebusiness_platform_guid);
            if (data) {
              this.$message.error(this.$t("visititem.add_platform_error"));
            } else {
              let item = {
                "model": "platform",
                "ebusiness_platform_guid": this.shopControl.ebusiness_platform_guid,
                "account": this.shopControl.account,
                "name": this.shopControl.name,
                "password": this.shopControl.password,
                "lockAccount": this.shopControl.lockAccount,
                "logo_url": this.shopControl.logo_info,
                "ebusiness_id": this.shopControl.ebusiness_platform_guid,
                "custom": false,
                "id": this.shopControl.ebusiness_platform_guid
              };
              this.$emit("success", { "method": "add", "item": item });
              this.setMode("add-btn");
            }
          }
        } else {
          if (this.choose_custom_platform) {
            yield API.post(`api://base.auth.pro/v1/shops/${this.shopGuid}/ext_ebusiness`, {
              "model": "custom",
              "name": this.custom_platform_name,
              "url": this.custom_platform_url,
              "account": this.shopControl.account,
              "password": this.shopControl.password,
              "lockAccount": this.shopControl.lockAccount
            });
          } else {
            yield API.post(`api://base.auth.pro/v1/shops/${this.shopGuid}/ext_ebusiness`, {
              "model": "platform",
              "id": this.shopControl.ebusiness_platform_guid,
              "account": this.shopControl.account,
              "password": this.shopControl.password,
              "lockAccount": this.shopControl.lockAccount
            });
          }
          this.$emit("success");
          this.setMode("add-btn");
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  save() {
    return __async(this, null, function* () {
      var _a, _b, _c;
      try {
        if (this.shopFlag) {
          if (this.edit_custom_platform) {
            let item = {
              "name": (_a = this.edit_custom_platform_name) != null ? _a : "\u81EA\u5B9A\u4E49",
              "url": (_b = this.edit_custom_platform_url) != null ? _b : "https://",
              "account": this.shopControl.account,
              "password": this.shopControl.password,
              "lockAccount": this.shopControl.lockAccount,
              "custom": true,
              "ebusiness_id": this.selected_item.ebusiness_id,
              "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/custom_small.png",
              "ebusiness_platform_guid": this.selected_item.ebusiness_platform_guid,
              "id": this.selected_item.ebusiness_platform_guid,
              "model": "custom"
            };
            this.$emit("success", { "method": "edit", "item": item });
            this.setMode("view");
          } else {
            if (this.shopControl.ebusiness_platform_guid === "" || this.shopControl.ebusiness_platform_guid === null) {
              this.$message.error(this.$t("visititem.add_platform_empty_error"));
              return;
            }
            let item = {
              "model": "platform",
              "ebusiness_platform_guid": this.shopControl.ebusiness_platform_guid,
              "name": this.shopControl.name,
              "account": this.shopControl.account,
              "password": this.shopControl.password,
              "lockAccount": this.shopControl.lockAccount,
              "logo_url": (_c = this.shopControl.logo_info) != null ? _c : this.selected_item.logo_url,
              "ebusiness_id": this.selected_item.ebusiness_id,
              "id": this.shopControl.ebusiness_platform_guid,
              "custom": false
            };
            this.$emit("success", { "method": "edit", "item": item });
            this.setMode("view");
          }
        } else {
          if (this.edit_custom_platform) {
            yield API.put(`api://base.auth.pro/v1/shops/${this.shopGuid}/ext_ebusiness/${this.selected_item.shop_ext_ebusiness_guid}`, {
              "model": "custom",
              "name": this.edit_custom_platform_name,
              "url": this.edit_custom_platform_url,
              "account": this.shopControl.account,
              "password": this.shopControl.password,
              "lockAccount": this.shopControl.lockAccount
            });
          } else {
            yield API.put(`api://base.auth.pro/v1/shops/${this.shopGuid}/ext_ebusiness/${this.selected_item.shop_ext_ebusiness_guid}`, {
              "model": "platform",
              "id": this.shopControl.ebusiness_platform_guid,
              "account": this.shopControl.account,
              "password": this.shopControl.password,
              "lockAccount": this.shopControl.lockAccount
            });
          }
          this.$emit("success");
          this.setMode("view");
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  deleteGroup() {
    return __async(this, null, function* () {
      try {
        if (this.shopFlag) {
          yield this.$confirm(this.$t("visititem.this_operation_will_delete_the_additional_access_platform_tip"), this.$t("visititem.this_operation_will_delete_the_additional_access_platform"), {
            customClass: "confirm-dark",
            confirmButtonText: this.$t("visititem.ok_delete"),
            cancelButtonText: this.$t("visititem.cancel"),
            confirmButtonClass: "btn-orange",
            cancelButtonClass: "btn-dark",
            roundButton: true
          });
          this.$emit("success", { "method": "delete", "item": this.selected_item });
        } else {
          yield this.$confirm(this.$t("visititem.this_operation_will_delete_the_additional_access_platform_tip"), this.$t("visititem.this_operation_will_delete_the_additional_access_platform"), {
            customClass: "confirm-dark",
            confirmButtonText: this.$t("visititem.ok_delete"),
            cancelButtonText: this.$t("visititem.cancel"),
            confirmButtonClass: "btn-orange",
            cancelButtonClass: "btn-dark",
            roundButton: true
          });
          yield API.delete(`api://base.auth.pro/v1/shops/${this.shopGuid}/ext_ebusiness/${this.selected_item.shop_ext_ebusiness_guid}`);
          this.$emit("success");
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  cancelAdd() {
    this.setMode("add-btn");
    this.custom_platform_name = "";
    this.custom_platform_url = "";
    this.choose_custom_platform = false;
  }
  chooseWebsite() {
    return __async(this, null, function* () {
      yield this._shopPlatform.open();
    });
  }
  select(item) {
    return __async(this, null, function* () {
      if (this.shopFlag) {
        this.shopControl.logo_info = item.plateinfo.logo_url;
        this.shopControl.name = item.plateinfo.name + "-" + item.webinfo.name;
        this.shopControl.ebusiness_platform_guid = item.webinfo.guid;
      } else {
        this.shopControl.name = item.webinfo.name;
        this.shopControl.ebusiness_platform_guid = item.webinfo.guid;
      }
    });
  }
  changeplate(data) {
    return __async(this, null, function* () {
      console.dir(data);
    });
  }
  setMode(mode) {
    this.mode = mode;
    this.refresh();
  }
  refresh() {
    this.refresh_key = UUID.v4();
    if (this.shopFlag) {
      if (this.mode == "edit") {
        if (this.selected_item.custom) {
          this.edit_custom_platform = true;
          this.edit_custom_platform_name = this.selected_item.name;
          this.edit_custom_platform_url = this.selected_item.url;
        } else {
          this.shopControl.name = this.selected_item.name;
          if (this.selected_item.ebusiness_id !== null && this.selected_item.ebusiness_id !== void 0) {
            this.shopControl.ebusiness_platform_guid = this.selected_item.ebusiness_id;
          } else if (this.selected_item.ebusiness_platform_guid !== null && this.selected_item.ebusiness_platform_guid !== void 0) {
            this.shopControl.ebusiness_platform_guid = this.selected_item.ebusiness_platform_guid;
          }
        }
        if (this.selected_item.lockAccount !== void 0) {
          this.shopControl.lockAccount = this.selected_item.lockAccount;
        }
        if (this.selected_item.lock_account !== void 0) {
          this.shopControl.lockAccount = this.selected_item.lock_account;
        }
        this.shopControl.account = this.selected_item.account;
        this.shopControl.password = this.selected_item.password;
      } else if (this.mode == "add") {
        this.shopControl.name = "";
        this.shopControl.ebusiness_platform_guid = "";
        this.shopControl.lockAccount = false;
        this.shopControl.account = null;
        this.shopControl.password = null;
      }
    } else {
      if (this.mode == "edit") {
        if (this.selected_item.is_custom) {
          this.edit_custom_platform = true;
          this.edit_custom_platform_name = this.selected_item.name;
          this.edit_custom_platform_url = this.selected_item.url;
        } else {
          this.shopControl.name = this.selected_item.name;
          if (this.selected_item.ebusiness_id !== null && this.selected_item.ebusiness_id !== void 0) {
            this.shopControl.ebusiness_platform_guid = this.selected_item.ebusiness_id;
          } else if (this.selected_item.ebusiness_platform_guid !== null && this.selected_item.ebusiness_platform_guid !== void 0) {
            this.shopControl.ebusiness_platform_guid = this.selected_item.ebusiness_platform_guid;
          }
        }
        if (this.selected_item.lockAccount !== void 0) {
          this.shopControl.lockAccount = this.selected_item.lockAccount;
        }
        if (this.selected_item.lock_account !== void 0) {
          this.shopControl.lockAccount = this.selected_item.lock_account;
        }
        this.shopControl.account = this.selected_item.account;
        this.shopControl.password = this.selected_item.password;
      } else if (this.mode == "add") {
        this.shopControl.name = "";
        this.shopControl.ebusiness_platform_guid = "";
        this.shopControl.lockAccount = false;
        this.shopControl.account = null;
        this.shopControl.password = null;
      }
    }
  }
};
__decorateClass([
  Prop({
    type: String,
    default: () => {
      return "";
    }
  })
], VisitItem.prototype, "shopGuid", 2);
__decorateClass([
  Prop({
    type: String,
    default: () => {
      return "add-btn";
    }
  })
], VisitItem.prototype, "initmode", 2);
__decorateClass([
  Prop({
    type: ExtEbusinessModel,
    default: () => {
      return new ExtEbusinessModel();
    }
  })
], VisitItem.prototype, "selecteditem", 2);
__decorateClass([
  Prop({
    type: Boolean,
    default: () => {
      return false;
    }
  })
], VisitItem.prototype, "shopFlag", 2);
__decorateClass([
  Prop({
    type: Array,
    default: () => {
      return [];
    }
  })
], VisitItem.prototype, "ebusinessList", 2);
__decorateClass([
  Ref("shop-platform")
], VisitItem.prototype, "_shopPlatform", 2);
VisitItem = __decorateClass([
  Component({
    components: {
      UiForm,
      Question,
      PasswordInput,
      ShopPlatforms
    }
  })
], VisitItem);
export {
  VisitItem as default
};
